export const ru = {
  "Add module": "Добавить модуль",
  "Are you sure?": "Вы уверены?",
  "auth": {
    "email": "Эл. почта",
    "enterEmail": "Введите вашу эл. почту",
    "enterName": "Введите ваше имя",
    "enterPassword": "Введите ваш пароль",
    "enterSurname": "Введите вашу фамилию",
    "forgotPassword": "Забыли пароль?",
    "name": "Имя",
    "password": "Пароль",
    "signIn": "Войти",
    "signUp": "Зарегистрироваться",
    "surname": "Фамилия"
  },
  "bots": {
    "bot": "Бот",
    "bots": "Боты",
    "botsTable": "Таблица ботов",
    "createBot": "Создать бота",
    "deleteBot": "Удалить бота",
    "editBot": "Редактировать бота",
    "table": {
      "createdAt": "Создано",
      "id": "ID",
      "identifier": "Идентификатор",
      "name": "Имя",
      "type": "Тип",
      "updatedAt": "Обновлено",
      "username": "Имя пользователя",
      "status": "Статус",
    },
    "viewBot": "Просмотр бота"
  },
  "buttons": {
    "addNewMessage": "Добавить новое сообщение",
    "apply": "Применить",
    "cancel": "Отмена",
    "create": "Создать",
    "delete": "Удалить",
    "deleteSelected": "Удалить выбранные",
    "edit": "Редактировать",
    "next": "Далее",
    "search": "Поиск",
    "select": "Выбрать",
    "skipAllDelay": "Пропустить все задержки",
    "update": "Обновить",
    "registration": "Регистрация",
    "regenerateDialog": "Перегенерировать диалог",
    "restore": "Восстановить",
  },
  "channels": {
    "addNewButton": "Добавить новую кнопку",
    "botAnswer": "Ответ бота",
    "botAnswerIsActive": "Ответ бота активен",
    "botAnswerIsNotActive": "Ответ бота не активен",
    "buttonText": "Текст кнопки",
    "buttonUrl": "URL кнопки",
    "channel": "Канал",
    "channels": "Каналы",
    "channelsTable": "Таблица каналов",
    "createChannel": "Создать канал",
    "deleteBotAnswer": "Удалить ответ бота",
    "deleteChannel": "Удалить канал",
    "deletePush": "Удалить пуш",
    "editBotAnswer": "Редактировать ответ бота",
    "editChannel": "Редактировать канал",
    "enterAfterTime": "Введите время задержки",
    "enterMessage": "Введите сообщение",
    "enterText": "Введите текст",
    "enterUrl": "Введите URL",
    "push": "Пуш",
    "selectButtonType": "Выберите тип кнопки",
    "selectChannel": "Выберите канал",
    "selectTemplateId": "Выберите ID шаблона",
    "selectType": "Выберите тип",
    "table": {
      "afterTime": "После времени",
      "createdAt": "Создано",
      "id": "ID",
      "identifier": "Идентификатор",
      "isActive": "Активен",
      "message": "Сообщение",
      "messageAt": "Время сообщения",
      "name": "Имя",
      "sourceId": "ID источника",
      "template": "Пуш",
      "type": "Тип",
      "updatedAt": "Обновлено"
    },
    "updatePush": "Обновить пуш",
    "viewChannel": "Просмотр канала",
    "noMessage": "Нет сообщения"
  },
  "dtos": {
    "link_one": "Ссылка",
    "link_other": "Ссылки"
  },
  "fields": {
    "channel_one": "Канал",
    "channel_other": "Каналы"
  },
  "footer": {
    "allRightsReserved": "Все права защищены"
  },
  "forms": {
    "apiHash": "API Hash",
    "apiId": "API ID",
    "botId": "ID бота",
    "buyer": "Покупатель",
    "channelId": "ID канала",
    "client": "Клиент",
    "code": "Код",
    "email": "Эл. почта",
    "enterApiHash": "Введите API Hash",
    "enterApiId": "Введите API ID",
    "enterBuyer": "Введите покупателя",
    "enterCode": "Введите код",
    "enterFbPixel": "Введите fbPixel",
    "enterFbToken": "Введите fbToken",
    "enterName": "Введите имя",
    "enterPassword": "Введите пароль",
    "enterPhoneNumber": "Введите номер телефона",
    "enterSource": "Введите источник",
    "enterUrl": "Введите URL",
    "enterUsername": "Введите имя пользователя",
    "fbPixel": "fbPixel",
    "fbToken": "fbToken",
    "name": "Имя",
    "description": "Описание",
    "text": "Текст",
    "password": "Пароль",
    "phoneNumber": "Номер телефона",
    "position": "Позиция",
    "role": "Роль",
    "selectBotId": "Выберите ID бота",
    "selectBots": "Выберите ботов",
    "selectChannelId": "Выберите ID канала",
    "selectChannels": "Выберите каналы",
    "selectSource": "Выберите источник",
    "selectSourceId": "Выберите ID источника",
    "selectSubscribers": "Выберите подписчиков",
    "source": "Источник",
    "sourceId": "ID источника",
    "surname": "Фамилия",
    "selectClient": "Выберите клиента",
  },
  "general": {
    "administrator": "Администратор",
    "administrators": "Администраторы",
    "approveTo": "Вы хотите {{ phrase }}?",
    "createAdministrator": "Создать администратора",
    "editAdministrator": "Редактировать администратора",
    "filters": "Фильтры",
    "home": "Главная",
    "pageNotFound": "Страница не найдена",
    "personalData": "Персональные данные",
    "table": {
      "dtoTable": "Таблица {{ dtoName }}",
      "noData": "Нет данных",
      "pagination": "Показано {{currCountOfRows}} из {{toCountOfRows}} из {{total}} записей"
    },
    "viewAdministrator": "Просмотр администратора"
  },
  "links": {
    "botsLink": "Ссылка бота",
    "channelsLink": "Ссылка канала",
    "contactDeveloper": "Связаться с разработчиком",
    "createBotsLink": "Создать ссылку бота",
    "createChannelsLink": "Создать ссылку канала",
    "link": "Ссылка",
    "links": "Ссылки",
    "support": "Поддержка",
    "table": {
      "deepLink": "Глубокая",
      "firstName": "Имя",
      "resource": "Ресурс",
      "subscribedAt": "Подписан",
      "showHiddenLinks": "Показать скрытые ссылки",
      "type": "Тип"
    },
    "viewLink": "Просмотр ссылки"
  },
  "managers": {
    "attemptsLeft": "Попытка: {{attemptsLeft}} / 3",
    "editManager": "Редактировать менеджера",
    "enterTgCode": "Проверьте Telegram и введите код ниже",
    "manager": "Менеджер",
    "managers": "Менеджеры",
    "managersTable": "Таблица менеджеров",
    "signIn": "Aвторизация",
    "signInQrCode": "Войти через QR код",
    "signInSendCode": "Войти с кодом",
    "signInSendCodeAndPassword": "Войти с кодом и паролем",
    "timeExpired": "Время истекло, попробуйте позже",
    "timeLeft": "Осталось времени: {{timeLeft}} секунд",
    "viewManager": "Просмотр менеджера"
  },
  "no": "Нет",
  "profile": {
    "hey": "Привет, {{name}}",
    "logOut": "Выйти"
  },
  "services": {
    "actors": "Актеры",
    "actor": "Актер",
    "actorsSettings": "Настройка актеров",
    "actorsSetting": "Настройка актера",
    "actorsTable": "Таблица актеров",
    "createActor": "Создать актера",
    "createGroup": "Создать группу",
    "createPrompt": "Создать подсказку",
    "createSetting": "Создать настройку",
    "deleteGroup": "Удалить группу",
    "dialogs": "Лента",
    "editActor": "Редактировать актера",
    "editGroup": "Редактировать группу",
    "editPrompt": "Редактировать подсказку",
    "editSetting": "Редактировать настройку",
    "createActorSetting": "Создать настройку актера",
    "viewActorSetting": "Просмотр настройку актера",
    "editActorSetting": "Редактировать настройку актера",
    "groups": "Группы",
    "groupsTable": "Таблица групп",
    "prompts": "Подсказки",
    "settings": "Настройки",
    "settingsTable": "Таблица настроек",
    "Dialog messages": "Сообщения диалога",
    "table": {
      "apiHash": "API Hash",
      "apiId": "API ID",
      "bio": "Биография",
      "createdAt": "Создано",
      "description": "Описание",
      "id": "ID",
      "key": "Ключ",
      "link": "Ссылка TG",
      "name": "Имя",
      "nick": "Ник",
      "note": "Заметка",
      "phone": "Телефон",
      "prompt": "Подсказка",
      "session": "Сессия",
      "sex": "Пол",
      "sheetLink": "Ссылка на лист",
      "updatedAt": "Обновлено",
      "value": "Значение"
    },
    "viewActor": "Просмотр актера",
    "viewGroup": "Просмотр группы",
    "viewPrompt": "Просмотр подсказки",
    "viewSetting": "Просмотр настройки"
  },
  "subscribers": {
    "createSubscriber": "Создать подписчика",
    "editSubscriber": "Редактировать подписчика",
    "subscribers": "Подписчики",
    "subscribersTable": "Таблица подписчиков",
    "table": {
      "bot": "Бот",
      "buyer": "Покупатель",
      "createdAt": "Создано",
      "id": "ID",
      "identifier": "Идентификатор",
      "isSent": "Отправлено успешно",
      "message": "Сообщение",
      "messages": "Сообщения",
      "name": "Имя",
      "received": "Получено",
      "resource": "Ресурс",
      "resources": "Ресурсы",
      "sendAt": "Время отправки",
      "sent": "Отправлено",
      "source": "Источник",
      "type": "Тип",
      "updatedAt": "Обновлено",
      "username": "Имя пользователя"
    },
    "viewSubscriber": "Просмотр подписчика"
  },
  "subscriptions": {
    "createSubscription": "Создать подписку",
    "editSubscription": "Редактировать подписку",
    "subscriptions": "Подписки",
    "subscriptionsTable": "Таблица подписок",
    "table": {
      "buyer": "Покупатель",
      "createdAt": "Создано",
      "id": "ID",
      "identifier": "Идентификатор",
      "name": "Имя",
      "resource": "Ресурс",
      "source": "Источник",
      "updatedAt": "Обновлено",
      "url": "URL",
      "username": "Имя пользователя"
    },
    "viewSubscription": "Просмотр подписки"
  },
  "users": {
    "createUser": "Создать пользователя",
    "createUserResource": "Создать ресурс пользователя",
    "deleteUser": "Удалить пользователя",
    "deleteUserResource": "Удалить ресурс пользователя",
    "editUser": "Редактировать пользователя",
    "editUserResource": "Редактировать ресурс пользователя",
    "table": {
      "createdAt": "Создано",
      "email": "Эл. почта",
      "id": "ID",
      "name": "Имя",
      "role": "Роль",
      "surname": "Имя пользователя",
      "showDelete": "Показывать удаленных",
      "updatedAt": "Обновлено",
    },
    "user": "Пользователь",
    "users": "Пользователи",
    "usersResource": "Ресурс пользователя",
    "usersResources": "Ресурсы пользователей",
    "usersResourcesTable": "Таблица ресурсов пользователей",
    "usersTable": "Таблица пользователей",
    "viewUser": "Просмотр пользователя",
    "viewUserResource": "Просмотр ресурса пользователя"
  },
  "validation": {
    "email": "Введите действительный адрес эл. почты",
    "invalidCode": "Введите правильный код",
    "invalidPassword": "Введите правильный пароль",
    "required": "{{field}} является обязательным полем"
  },
  "yes": "Да",
  "ContactManager": "Cвязаться с менеджером",
  "Show only messaged": "Показать только с сообщениями"
};
